/* eslint-disable @typescript-eslint/no-explicit-any */

export class ResponsePagination {
  items: Array<any>;
  totalItems: number;
  currentPage: number;
  totalPages: number;
  limit: number;

  static fromJson(json: any): any {
    const response = new ResponsePagination();
    response.items = json.items || [];
    response.totalItems = json.totalItems || 0;
    response.currentPage = json.currentPage || 0;
    response.totalPages = json.totalPages || 0;
    response.limit = json.limit || [];

    return response;
  }
  static isResponsePagination(obj: any): boolean {
    return (
      obj &&
      obj.items &&
      obj.totalItems &&
      obj.currentPage &&
      obj.totalPages &&
      obj.limit
    );
  }
}
